module.exports = __webpack_public_path__ + "img/chinesecompany85.f048cf14.png";